
import { TextField } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { DesktopDatePicker, DesktopDateTimePicker, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { validateStartEndDate } from '../../../services/services';
import { updateDateStartEnd } from '../../../../../stateManagement/actions/manageCouponActions';
import { labelMappings } from '../../../utils/utils';
import { UsabilityLimitsProps } from '../../../types';



function DateTimeSelector({ setDateChanged }: UsabilityLimitsProps) {

    const { startDate, endDate, } = useSelector((state: any) => state?.manageCoupons?.data?.recurrence?.dateStartEnd);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const { couponEditType } = useSelector((state: any) => state.manageCoupons?.data);
    const handleStartDate = (newValue: Dayjs | null) => {
        if (couponEditType === "edit" && dayjs(newValue).startOf('day').format("YYYY-MM-DDTHH:mm:ss") !== startDate) {
            setDateChanged(true)
        }
        // updateUsabilityLimits("startDate",dayjs(newValue).startOf('day').format("YYYY-MM-DDTHH:mm:ss"));
        updateDateStartEnd("startDate", dayjs(newValue).startOf('day').format("YYYY-MM-DDTHH:mm:ss"));
    }

    const handleEndDate = (newValue: Dayjs | null) => {
        if (couponEditType === "edit" && dayjs(newValue).startOf('day').format("YYYY-MM-DDTHH:mm:ss") !== endDate) {
            setDateChanged(true)
        }
        updateDateStartEnd("endDate", dayjs(newValue).endOf('day').format("YYYY-MM-DDTHH:mm:ss"));
    }

    useEffect(() => {
        const res = validateStartEndDate();
        setErrors(res);
    }, [startDate, endDate]);

    return (
        <>
            <div className={"textFieldOutline"} style={{
                backgroundColor: "#f3fcfb",
                display: 'flex',
                alignItems: "center",
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: "lightgray",
                // marginBottom: "10px",
                // marginTop: "10px",
            }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div style={{
                        display: "flex", alignItems: "center", height: "100%", borderRadius: "5px",
                        padding: "0px 20px 0px 20px"
                    }}>
                        <p style={{
                            whiteSpace: "nowrap", gap: "10",
                            fontSize: '16px', alignItems: "center", justifyContent: "center", color: "#24c6b1", fontWeight: "bold"
                        }}>{labelMappings["date-range-picker"]}</p>
                    </div>
                    <div className="" style={{ display: 'flex', justifyContent: 'space-evenly', gap: '25px', width: "100%", margin: "10px 10px 10px 0px", background: "white" }}>
                        <DesktopDatePicker
                            label="Start Date"
                            value={startDate}
                            inputFormat="DD/MM/YYYY"
                            minDate={dayjs()}
                            onChange={handleStartDate}
                            renderInput={(params) => <TextField {...params} {...(errors['startDate'] && { error: true, helperText: errors['startDate'] })} />}
                        />
                        <DesktopDatePicker
                            label="End Date"
                            value={endDate}
                            inputFormat="DD/MM/YYYY"
                            minDate={dayjs()}
                            onChange={handleEndDate}
                            renderInput={(params) => <TextField {...params} {...(errors['endDate'] && { error: true, helperText: errors['endDate'] })} />}
                        />
                    </div>
                </LocalizationProvider>
            </div>
        </>
    )
}

export default DateTimeSelector;